const selfServeRoutes = [
  {
    path: '/mail/:directMailCampaignGuid/request-a-callback',
    name: 'direct-mail-request-a-callback',
    component: () => import('@/components/archistar/direct-mail/RequestACallback.vue'),
    meta: {
      noAuthRequired: true
    }
  }
];

export default selfServeRoutes;
